import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from 'react-router-dom';

import RenderRoute from '../RenderRoute';

const propTypes = {
  routes: PropTypes.array.isRequired,
};

const Routes = ({ routes }) => (
  <Switch>
    {routes.map((route, index) => (
      <RenderRoute key={index} {...route} />
    ))}
  </Switch>
);

Routes.propTypes = propTypes;

export default Routes;
